<div [ngStyle]="{backgroundColor: 'rgba(' + color.value[0] + ',0,0)'}" col-r>
  <mat-slider max="255" min="0">
    <input (change)="rgbChange()" [(ngModel)]="color.value[0]" matSliderThumb>
  </mat-slider>
</div>
<div [ngStyle]="{backgroundColor: 'rgba(0,' + color.value[1] + ',0)'}" col-g>
  <mat-slider max="255" min="0">
    <input (change)="rgbChange()" [(ngModel)]="color.value[1]" matSliderThumb>
  </mat-slider>
</div>
<div [ngStyle]="{backgroundColor: 'rgba(0,0,' + color.value[2] + ')'}" col-b>
  <mat-slider max="255" min="0">
    <input (change)="rgbChange()" [(ngModel)]="color.value[2]" matSliderThumb>
  </mat-slider>
</div>
<div col-h>
  <mat-slider max="360" min="0">
    <input [(ngModel)]="hue" matSliderThumb>
  </mat-slider>
</div>
<div col-s>
  <mat-slider max="100" min="0">
    <input [(ngModel)]="saturation" matSliderThumb>
  </mat-slider>
</div>
<div col-l>
  <mat-slider max="100" min="0">
    <input [(ngModel)]="lightness" matSliderThumb>
  </mat-slider>
</div>
